export default "__VITE_ASSET__SWWVqHqf__"